import stESign from './eSign.component';

export default angular.module('st.Integrations.ESign', []).component('stESign', stESign);
